// One entry point for "re-stamp what is still queued onto freshly fetched ride
// rows". Every revalidation that writes server rides into the cache goes
// through this, so a queued REVIEW press (#3088) and a queued section move
// (#3293) both survive it.
import { overlayPendingReviewRequests } from "./reviewRequests";
import { overlayPendingSubsections } from "./rideSubsections";

export async function overlayPendingRideOps(rows) {
  return overlayPendingSubsections(await overlayPendingReviewRequests(rows));
}
